import { coachPersonas } from './personas';

export const EMPATHEAR_ID = 'arjun';

export type RecommendationInput = {
  role?: string | null;
  experience?: string | null;
  industry?: string | null;
  supportNeed?: string | null;
};

export const goalToCoachMap: Record<string, string[]> = {
  'Leadership Skills': ['rajesh'],
  'Time Management': ['samuel'],
  'Conflict Resolution': ['arjun'],
  'Public Speaking': ['priya'],
  'Strategic Thinking': ['meera'],
  'Team Collaboration': ['rajesh', 'samuel'],
};

export const roleToCoachMap: Record<string, string[]> = {
  'Software Engineer': ['samuel', 'meera'],
  'Product Manager': ['rajesh', 'meera'],
  'Designer': ['priya', 'aisha'],
  'Data Scientist': ['meera', 'samuel'],
  'Marketing Manager': ['priya', 'rajesh'],
  'Sales Representative': ['rajesh', 'arjun'],
  'Human Resources': ['arjun', 'aisha'],
};

export const experienceToCoachMap: Record<string, string[]> = {
  '0-2 years': ['priya', 'samuel'],
  '3-5 years': ['samuel', 'meera'],
  '6-10 years': ['rajesh', 'meera'],
  '10+ years': ['rajesh', 'arjun'],
};

export const industryToCoachMap: Record<string, string[]> = {
  'Technology': ['samuel', 'meera'],
  'Finance': ['rajesh', 'samuel'],
  'Healthcare': ['priya', 'aisha'],
  'Education': ['priya', 'aisha'],
  'Consulting': ['rajesh', 'meera'],
  'Manufacturing': ['rajesh', 'samuel'],
  'Retail': ['samuel', 'aisha'],
  'Government': ['rajesh', 'arjun'],
  'Non-profit': ['aisha', 'arjun'],
  'Media & Entertainment': ['priya', 'meera'],
  'Other': ['meera', 'aisha'],
};

export const supportNeedToCoachMap: Record<string, string[]> = {
  'I want to get better results from my work.': ['samuel'],
  'I want clarity about my next career step / career path': ['priya'],
  'I feel overwhelmed and want more balance in my life / understand what really matters to me.': ['aisha'],
  'I want to show up better as a leader': ['rajesh'],
  'I am going through a professional change (new job / role / project) and feel unsure.': ['meera'],
  'I just need to talk and feel heard.': ['arjun'],
};

export function computeCoachRecommendations({ role, experience, industry, supportNeed }: RecommendationInput): string[] {
  const scoreMap = new Map<string, number>();

  const addScore = (coachId: string, weight: number) => {
    scoreMap.set(coachId, (scoreMap.get(coachId) ?? 0) + weight);
  };

  if (role && roleToCoachMap[role]) {
    roleToCoachMap[role].forEach((coachId) => addScore(coachId, 2));
  }

  if (experience && experienceToCoachMap[experience]) {
    experienceToCoachMap[experience].forEach((coachId) => addScore(coachId, 1));
  }

  if (industry && industryToCoachMap[industry]) {
    industryToCoachMap[industry].forEach((coachId) => addScore(coachId, 1.5));
  }

  if (supportNeed && supportNeedToCoachMap[supportNeed]) {
    supportNeedToCoachMap[supportNeed].forEach((coachId) => addScore(coachId, 4));
  }

  const sorted = Array.from(scoreMap.entries())
    .sort((a, b) => b[1] - a[1])
    .map(([coachId]) => coachId);

  const remaining = coachPersonas
    .map((persona) => persona.id)
    .filter((id) => !sorted.includes(id));

  const combined = [...sorted, ...remaining];

  if (!combined.length) {
    return coachPersonas.map((persona) => persona.id);
  }

  if (!combined.includes(EMPATHEAR_ID)) {
    combined.push(EMPATHEAR_ID);
  }

  return combined;
}
